import { ISquadCatchUpsModel } from 'domain/store/catchUps/SquadCatchUpsModel';
import { useStore } from './useStore';

export function useSquadCatchUps(): ISquadCatchUpsModel {
  const { squadCatchUps } = useStore();

  return squadCatchUps;
}
